export default "__VITE_ASSET__feab263d__"